import React from 'react';
import * as Styles from './Button.styles';

export type VariantColor = 'yellow' | 'blue' | 'red' | 'gray';
export type VariantStyle = 'filled' | 'outline';
export type ButtonSize = 'mini' | 'small' | 'medium' | 'large';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  variantStyle?: VariantStyle;
  variantColor?: VariantColor;
  size?: ButtonSize;
}

const Button = ({
  children,
  href,
  size = 'medium',
  variantStyle = 'filled',
  variantColor = 'blue',
  ...props
}: ButtonProps): JSX.Element => {
  const sharedStyle = {
    $size: size,
    $variantColor: variantColor,
    $variantStyle: variantStyle,
  };

  if (href) {
    return (
      <Styles.Link to={href} {...sharedStyle}>
        {children}
      </Styles.Link>
    );
  }
  return (
    <Styles.Button {...props} {...sharedStyle}>
      {children}
    </Styles.Button>
  );
};

export default Button;
